<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">A Dictionary of Foreign Words and Phrases</h1>
<p class="author">A. J. Bliss</p>
<div class="img_container1">
<img alt="Images" src="images/PhilosophicalLibrary-Sw_fmt.jpg"/>
</div>
<div class="img_container">
<img alt="Images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2d4b7035